import React, { Fragment, useEffect, useState } from "react";
import {
  Row,
  Form,
  Button,
  InputGroup,
  ToastContainer,
  Toast,
  Col,
} from "react-bootstrap";
import Select from "react-select";
import { CurrencyRupeeIcon } from "@heroicons/react/outline";
import { MessageRateTable } from "components/Tables";
import {
  useGetRoutesListMutation,
  usePostRateMutation,
  useUserDropDownMutation,
} from "Services/services";
import hasPermission from "pages/Permissions";

export default () => {
  //usertype
  const userData = localStorage.getItem("TOKEN");
  const userObject = JSON.parse(userData);
  // const userType = userObject.user_type;

  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastVariant, setToastVariant] = useState("success");

  const [refreshTable, setRefreshTable] = useState(false);

  const [peOptions, setPeOptions] = useState([]);
  const [user, setUser] = useState();
  const [email, setEmail] = useState();
  const [userEmails, setUserEmails] = useState();
  const [channel, setChannel] = useState("whatsapp");
  // const [category, setCategory] = useState('');

  const [routeData, setRouteData] = useState({});
  const [options, setOptions] = useState("");
  const [routeName, setRouteName] = useState();
  const [fetchedCost, setFetchedCost] = useState();
  const [editedCost, setEditedCost] = useState(0);

  const [promoCost, setPromoCost] = useState("");
  const [transCost, setTransCost] = useState("");
  const [authCost, setAuthCost] = useState("");

  const [userList] = useUserDropDownMutation();
  const [RoutesList] = useGetRoutesListMutation();
  const [createRates] = usePostRateMutation();

  const canEdit = hasPermission("WA Rates", "edit");

  // Validation states
  const [validated, setValidated] = useState(false);
  const [selectErrors, setSelectErrors] = useState({
    user: false,
    routeName: false,
    transCost: false,
    promoCost: false,
    authCost: false,
  });

  // refresh all
  const refreshAll = () => {
    setUser();
    setChannel("");
    setRouteData({});
    setRouteName();
    // setFetchedCost();
    // setEditedCost();
    setTransCost("");
    setPromoCost("");
    setAuthCost("");
    setValidated(false);
    setSelectErrors({
      user: false,
      routeName: false,
      transCost: false,
      promoCost: false,
      authCost: false,
    });
  };

  // entity options set
  useEffect(() => {
    fetchEntity();
    fetchRouteName();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchEntity = async () => {
    try {
      const response = await userList({ user_type: 4 });
      if (response?.data?.statusCode === 200) {
        const userOptions = response?.data?.data?.user_details.map(
          (option) => ({
            value: option.id,
            label: option.user_name,
          })
        );
        const userEmail = response?.data?.data?.user_details.map((option) => ({
          value: option.id,
          label: option.email,
        }));
        setUserEmails(userEmail);
        setPeOptions(userOptions);
      } else {
        setPeOptions([]);
        setUserEmails([]);
      }
    } catch (error) {
      setPeOptions([]);
      setUserEmails([]);
    }
  };

  const fetchRouteName = async () => {
    try {
      const response = await RoutesList({ message_type: channel });
      if (response?.data?.statusCode === 200) {
        const routeOptions = response?.data?.data?.rows.map((option) => ({
          value: option.id,
          label: option.route_name,
        }));
        setOptions(routeOptions);
      } else {
        setOptions([]);
      }
    } catch (error) {
      setOptions([]);
    }
  };

  const validateForm = () => {
    const errors = {
      user: !user,
      routeName: !routeName,
      transCost: !transCost || transCost === "" || transCost === "0",
      promoCost: !promoCost || promoCost === "" || promoCost === "0",
      authCost: !authCost || authCost === "" || authCost === "0",
    };

    setSelectErrors(errors);
    return !Object.values(errors).some(error => error);
  };

  const sendRate = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const isFormValid = validateForm();

    if (!isFormValid) {
      setValidated(true);
      return;
    }

    const postData = {
      associated_enterprise_id: user.value,
      message_type: channel,
      promotional_rate: promoCost,
      transactional_rate: transCost,
      authentication_rate: authCost,
      route_id: routeName.value,
      status: "active",
      email: email,
    };

    createRates(postData)
      .then((success) => {
        if (success?.data?.status === 200) {
          setToastMessage(success?.data?.message);
          setToastVariant("success");
          setRefreshTable(!refreshTable);
          refreshAll();
        } else if (success?.data?.statusCode > 300) {
          setToastMessage(success?.data?.message || "Upload failed!");
          setToastVariant("danger");
        }
        setShowToast(true);
      })
      .catch((error) => {
        setToastMessage(error?.data?.message || "Upload failed");
        setToastVariant("danger");
        setShowToast(true);
      });

    setValidated(true);
  };

  const RequiredLabel = ({ label }) => (
    <Form.Label>
      {label}
      <span className="text-danger"> * </span>
    </Form.Label>
  );

  return (
    <Fragment>
      <ToastContainer position="top-end" className="p-3">
        <Toast
          bg={toastVariant}
          show={showToast}
          onClose={() => setShowToast(false)}
          delay={3000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">Message Rate Creation</strong>
          </Toast.Header>
          <Toast.Body>{toastMessage}</Toast.Body>
        </Toast>
      </ToastContainer>

      {canEdit && (
        <Form border="0" className="card mb-4" noValidate validated={validated} autoComplete="off" onSubmit={sendRate}>
          <h5 className="mb-4">General information</h5>
          <Row>
            <Form.Group as={Col} xs={12} md={6} lg={4} className="mb-3">
              <RequiredLabel label="Enterprise" />
              <Select
                required
                placeholder="Select User"
                className="mb-0"
                isSearchable={true}
                options={peOptions}
                value={user || ""}
                onChange={(selectedOption) => {
                  setUser(selectedOption);
                  setSelectErrors(prev => ({
                    ...prev,
                    user: false
                  }));
                  userEmails.map((element) => {
                    if (element.value == selectedOption?.value) setEmail(element.label);
                  });
                }}
                styles={{
                  control: (provided, state) => ({
                    ...provided,
                    borderColor: validated && selectErrors.user ? '#dc3545' : validated && !selectErrors.user && user ? '#65BB82': provided.borderColor,
                    borderRadius: '0.75rem',
                  }),
                }}
              />
              {validated && selectErrors.user && (
                <div className="invalid-feedback d-block">
                  Enterprise selection is required.
                </div>
              )}
            </Form.Group>

            <Form.Group as={Col} xs={12} md={6} lg={4} className="mb-3">
              <RequiredLabel label="Message Type" />
              <Form.Select disabled value={channel}>
                <option value="" disabled>
                  Select Channel
                </option>
                {/* <option value="sms">SMS</option> */}
                <option value="whatsapp" defaultChecked>WhatsApp</option>
                {/* <option value="rcs">RCS</option> */}
              </Form.Select>
            </Form.Group>

            <Form.Group as={Col} xs={12} md={6} lg={4} className="mb-3">
              <RequiredLabel label="Route Name" />
              <Select
                required
                placeholder="Select Route"
                className="mb-0"
                isSearchable={true}
                options={options}
                value={routeName || ""}
                onChange={(selectedOption) => {
                  setRouteName(selectedOption);
                  setSelectErrors(prev => ({
                    ...prev,
                    routeName: false
                  }));
                }}
                isDisabled={!channel}
                styles={{
                  control: (provided, state) => ({
                    ...provided,
                    borderColor: validated && selectErrors.routeName ? '#dc3545' : validated && !selectErrors.routeName && routeName ? '#65BB82': provided.borderColor,
                    borderRadius: '0.75rem',
                  }),
                }}
              />
              {validated && selectErrors.routeName && (
                <div className="invalid-feedback d-block">
                  Route selection is required.
                </div>
              )}
            </Form.Group>

            <Form.Group as={Col} xs={12} md={6} lg={4} className="mb-3">
              <RequiredLabel label="Transactional Rate" />
              <InputGroup>
                <InputGroup.Text className="text-gray-600">
                  <CurrencyRupeeIcon className="icon icon-xs" />
                </InputGroup.Text>
                <Form.Control
                  required
                  type="text"
                  placeholder="1,000"
                  value={transCost}
                  title="Transactional rate must be a valid number"
                  onChange={(e) => {
                    const val = e.target.value;
                    // Allow only numbers with up to two decimal places
                    if (val === "" || /^\d+(\.\d{0,5})?$/.test(val)) {
                      setTransCost(val);
                      setSelectErrors(prev => ({
                        ...prev,
                        transCost: false
                      }));
                    }
                  }}
                  isInvalid={validated && selectErrors.transCost}
                  isValid={validated && !selectErrors.transCost && transCost && transCost !== "0"}
                  autoComplete="new-transCost"
                />
              </InputGroup>
                <Form.Control.Feedback type="invalid">
                  Enter a valid Transactional Rate.
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} xs={12} md={6} lg={4} className="mb-3">
              <RequiredLabel label="Promotional Rate" />
              <InputGroup>
                <InputGroup.Text className="text-gray-600">
                  <CurrencyRupeeIcon className="icon icon-xs" />
                </InputGroup.Text>
                <Form.Control
                  required
                  type="text"
                  placeholder="1,000"
                  value={promoCost}
                  title="Promotional rate must be a valid number"
                  onChange={(e) => {
                    const val = e.target.value;
                    // Allow only numbers with up to two decimal places
                    if (val === "" || /^\d+(\.\d{0,5})?$/.test(val)) {
                      setPromoCost(val);
                      setSelectErrors(prev => ({
                        ...prev,
                        promoCost: false
                      }));
                    }
                  }}
                  isInvalid={validated && selectErrors.promoCost}
                  isValid={validated && !selectErrors.promoCost && promoCost && promoCost !== "0"}
                  autoComplete="new-promoCost"
                  />
                  </InputGroup>
                <Form.Control.Feedback type="invalid">
                  Enter a valid Promotional Rate.
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} xs={12} md={6} lg={4} className="mb-3">
              <RequiredLabel label="Authentication Rate" />
              <InputGroup>
                <InputGroup.Text className="text-gray-600">
                  <CurrencyRupeeIcon className="icon icon-xs" />
                </InputGroup.Text>
                <Form.Control
                  required
                  type="text"
                  placeholder="1,000"
                  value={authCost}
                  title="Authentication rate must be a valid number"
                  onChange={(e) => {
                    const val = e.target.value;
                    // Allow only numbers with up to two decimal places
                    if (val === "" || /^\d+(\.\d{0,5})?$/.test(val)) {
                      setAuthCost(val);
                      setSelectErrors(prev => ({
                        ...prev,
                        authCost: false
                      }));
                    }
                  }}
                  isInvalid={validated && selectErrors.authCost}
                  isValid={validated && !selectErrors.authCost && authCost && authCost !== "0"}
                  autoComplete="new-authCost"
                />
              </InputGroup>
                <Form.Control.Feedback type="invalid">
                  Enter a valid Authentication Rate.
                </Form.Control.Feedback>
            </Form.Group>

            <Col xs={12} className="d-flex justify-content-end">
              <Button
                variant="secondary"
                className="animate-up-2 mt-2"
                type="submit"
              >
                Submit
              </Button>
            </Col>
          </Row>
        </Form>
      )}

      <MessageRateTable key={refreshTable} />
    </Fragment>
  );
};
